import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";

const CAMPOS_DISPONIBLES = [
  "lead.nombre",
  "lead.empresa",
  "lead.email",
  "lead.telefono",
  "lead.estado",
  "productos",
  "total_presupuesto",
  "texto_presupuesto",
  "fecha_envio"
];

export default function WebhookDialog({ open, onClose, onSubmit, webhook, isLoading }) {
  const [formData, setFormData] = useState({
    nombre: "",
    url: "",
    tipo_evento: "presupuesto_erp",
    campos_incluir: [],
    activo: true
  });

  useEffect(() => {
    if (webhook) {
      setFormData(webhook);
    } else {
      setFormData({
        nombre: "",
        url: "",
        tipo_evento: "presupuesto_erp",
        campos_incluir: [],
        activo: true
      });
    }
  }, [webhook, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const toggleCampo = (campo) => {
    const campos = formData.campos_incluir || [];
    if (campos.includes(campo)) {
      setFormData({
        ...formData,
        campos_incluir: campos.filter(c => c !== campo)
      });
    } else {
      setFormData({
        ...formData,
        campos_incluir: [...campos, campo]
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-xl dark:bg-gray-900">
        <DialogHeader>
          <DialogTitle className="text-2xl text-gray-900 dark:text-white">
            {webhook ? "Editar Webhook" : "Nuevo Webhook"}
          </DialogTitle>
        </DialogHeader>
        
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 py-4">
            <div>
              <Label htmlFor="nombre" className="dark:text-gray-300">Nombre *</Label>
              <Input
                id="nombre"
                value={formData.nombre}
                onChange={(e) => setFormData({...formData, nombre: e.target.value})}
                required
                placeholder="Ej: Webhook ERP Principal"
                className="dark:bg-gray-800 dark:border-gray-700"
              />
            </div>

            <div>
              <Label htmlFor="url" className="dark:text-gray-300">URL *</Label>
              <Input
                id="url"
                type="url"
                value={formData.url}
                onChange={(e) => setFormData({...formData, url: e.target.value})}
                required
                placeholder="https://api.ejemplo.com/webhook"
                className="dark:bg-gray-800 dark:border-gray-700"
              />
            </div>

            <div>
              <Label htmlFor="tipo" className="dark:text-gray-300">Tipo de Evento *</Label>
              <Select 
                value={formData.tipo_evento} 
                onValueChange={(val) => setFormData({...formData, tipo_evento: val})}
              >
                <SelectTrigger className="dark:bg-gray-800 dark:border-gray-700">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="presupuesto_erp">Presupuesto a ERP</SelectItem>
                  <SelectItem value="lead_creado">Lead Creado</SelectItem>
                  <SelectItem value="lead_actualizado">Lead Actualizado</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label className="dark:text-gray-300 mb-3 block">Campos a Incluir</Label>
              <div className="space-y-2 max-h-48 overflow-y-auto border border-gray-200 dark:border-gray-700 rounded-md p-3">
                {CAMPOS_DISPONIBLES.map((campo) => (
                  <div key={campo} className="flex items-center space-x-2">
                    <Checkbox
                      id={campo}
                      checked={(formData.campos_incluir || []).includes(campo)}
                      onCheckedChange={() => toggleCampo(campo)}
                    />
                    <label
                      htmlFor={campo}
                      className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 dark:text-gray-300"
                    >
                      {campo}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} disabled={isLoading}>
              Cancelar
            </Button>
            <Button type="submit" disabled={isLoading} className="bg-indigo-600 hover:bg-indigo-700">
              {isLoading ? "Guardando..." : webhook ? "Actualizar" : "Crear"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}